/* eslint-disable no-unused-vars */
import React, {
  Component,
  useContext,
  useCallback,
  useRef,
  useEffect,
  useState,
} from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

/**
 * 前回値を保持する custom hook
 * @param {*} value 前回値を保持したい value
 * @return {?*} 前回値を返します
 */
export const usePrevious = value => {
  const previousRef = useRef(null);
  useEffect(() => {
    previousRef.current = value;
  }, [value]);
  return previousRef.current;
};

/**
 * `config.embedded` から embedded option boolean 状態を返す custom hook
 * @param {*} config React.Context.state.config
 * @return {boolean} config.embedded value - checked 結果を返します
 */
export const useShouldEmbeddedCheck = config => {
  const [checked, setChecked] = useState(config.embedded);
  useEffect(() => {
    if (checked !== config.embedded) {
      setChecked(config.embedded);
    }
  }, [checked, setChecked, config]);

  return checked;
};



// WEBPACK FOOTER //
// ./src/embedded-type/hooks/index.js